export const LIQUID_ID_ASPECT_RATIO = 1.192;
export const LIQUID_ID_FACES_LENGTH = 6;
